import axios from "axios";
import { toast } from "react-toastify";

import {
  DownloadExperienceResponseBodyType,
  FileExportExperienceFrontendRequestBodyType,
  FileExportId,
} from "@intelligems/ig-types";
import { TinybirdExperimentAnalysisInput } from "@src/api/analytics/types";
import { useBuildTinybirdPayload } from "@src/api/analytics/use-build-tinybird-payload";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const fileExportExperience = async (
  data: FileExportExperienceFrontendRequestBodyType
) => {
  const resp = await api.post<DownloadExperienceResponseBodyType>(
    `/v2/experience/file-export`,
    data
  );
  return resp.data;
};
export const useFileExportExperience = (
  params: TinybirdExperimentAnalysisInput
) => {
  const buildTinybirdPayload = useBuildTinybirdPayload();

  return useMutation<DownloadExperienceResponseBodyType, Error, FileExportId>({
    mutationFn: async (exportType: FileExportId) =>
      fileExportExperience({
        ...buildTinybirdPayload.build(
          params,
          {
            datasetId: exportType,
            metrics: [],
          },
          "exports"
        ),
        exportType,
      }),
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          // Do nothing
        } else {
          toast.error(`Something went wrong... ${error.message}`);
        }
      }
    },
  });
};
